export const LOAD_TIME_SLOT_LIST = 'new-booking/LOAD_TIME_SLOT_LIST';
export const LOAD_TIME_SLOT_LIST_SUCCESS =
  'new-booking/LOAD_TIME_SLOT_LIST_SUCCESS';
export const LOAD_TIME_SLOT_LIST_ERROR =
  'new-booking/LOAD_TIME_SLOT_LIST_ERROR';

export const HOLD_BOOKING_SLOT = 'new-booking/HOLD_BOOKING_SLOT';
export const HOLD_BOOKING_SLOT_SUCCESS =
  'new-booking/HOLD_BOOKING_SLOT_SUCCESS';
export const HOLD_BOOKING_SLOT_ERROR = 'new-booking/HOLD_BOOKING_SLOT_ERROR';

export const RELEASE_BOOKING_SLOT = 'new-booking/RELEASE_BOOKING_SLOT';
export const RELEASE_BOOKING_SLOT_SUCCESS =
  'new-booking/RELEASE_BOOKING_SLOT_SUCCESS';
export const RELEASE_BOOKING_SLOT_ERROR =
  'new-booking/RELEASE_BOOKING_SLOT_ERROR';

export const BOOK_APPOINTMENT = 'new-booking/BOOK_APPOINTMENT';
export const BOOK_APPOINTMENT_SUCCESS = 'new-booking/BOOK_APPOINTMENT_SUCCESS';
export const BOOK_APPOINTMENT_ERROR = 'new-booking/BOOK_APPOINTMENT_ERROR';

export const SAVE_SELECTED_BOOKING_SLOT =
  'new-booking/SAVE_SELECTED_BOOKING_SLOT';
export const SAVE_SELECTED_BOOKING_SLOT_SUCCESS =
  'new-booking/SAVE_SELECTED_BOOKING_SLOT_SUCCESS';
export const SAVE_SELECTED_BOOKING_SLOT_ERROR =
  'new-booking/SAVE_SELECTED_BOOKING_SLOT_ERROR';

export const CLEAR_SELECTED_BOOKING_SLOT =
  'new-booking/CLEAR_SELECTED_BOOKING_SLOT';
export const CLEAR_SELECTED_BOOKING_SLOT_SUCCESS =
  'new-booking/CLEAR_SELECTED_BOOKING_SLOT_SUCCESS';
export const CLEAR_SELECTED_BOOKING_SLOT_ERROR =
  'new-booking/CLEAR_SELECTED_BOOKING_SLOT_ERROR';

export const LOAD_BOOKING_DETAIL = 'new-booking/LOAD_BOOKING_DETAIL';
export const LOAD_BOOKING_DETAIL_SUCCESS =
  'new-booking/LOAD_BOOKING_DETAIL_SUCCESS';
export const LOAD_BOOKING_DETAIL_ERROR =
  'new-booking/LOAD_BOOKING_DETAIL_ERROR';

export const RESET_BOOKING_DETAIL = 'new-booking/RESET_BOOKING_DETAIL';

export const RESET_CURRENT_HOLDING_SLOT =
  'new-booking/RESET_CURRENT_HOLDING_SLOT';

export const LOAD_BOOKING_LIST = 'manage-booking/LOAD_BOOKING_LIST';
export const LOAD_BOOKING_LIST_SUCCESS =
  'manage-booking/LOAD_BOOKING_LIST_SUCCESS';
export const LOAD_BOOKING_LIST_ERROR = 'manage-booking/LOAD_BOOKING_LIST_ERROR';

export const RESCHEDULE_BOOKING = 'booking-detail/RESCHEDULE_BOOKING';
export const RESCHEDULE_BOOKING_SUCCESS =
  'booking-detail/RESCHEDULE_BOOKING_SUCCESS';
export const RESCHEDULE_BOOKING_ERROR =
  'booking-detail/RESCHEDULE_BOOKING_ERROR';

export const CANCEL_BOOKING = 'booking-detail/CANCEL_BOOKING';
export const CANCEL_BOOKING_SUCCESS = 'booking-detail/CANCEL_BOOKING_SUCCESS';
export const CANCEL_BOOKING_ERROR = 'booking-detail/CANCEL_BOOKING_ERROR';

export const UPDATE_BOOKING_INFO = 'booking-detail/UPDATE_BOOKING_INFO';
export const UPDATE_BOOKING_INFO_SUCCESS =
  'booking-detail/UPDATE_BOOKING_INFO_SUCCESS';
export const UPDATE_BOOKING_INFO_ERROR =
  'booking-detail/UPDATE_BOOKING_INFO_ERROR';

export const RESET_BOOKING_LIST = 'manage-booking/RESET_BOOKING_LIST';

export const RESET_TIME_SLOT_DATA = 'manage-booking/RESET_TIME_SLOT_DATA';
